import { Component, input } from '@angular/core';
import { DeviceSyncStatus, SyncType } from '@era/locations-sdk';
import { DeviceMdmSyncRetryContainerComponent } from '../device-mdm-sync/device-mdm-sync-retry/device-mdm-sync-retry.container';
import { DeviceSyncStatusIndicatorComponent } from './device-sync-status-indicator.component';
import { DeviceSyncStatusRetryContainerComponent } from './device-sync-status-retry.container';

@Component({
  selector: 'era-device-sync-status-ui',
  templateUrl: './device-sync-status.component.html',
  imports: [
    DeviceSyncStatusIndicatorComponent,
    DeviceSyncStatusRetryContainerComponent,
    DeviceMdmSyncRetryContainerComponent,
  ],
})
export class DeviceSyncStatusComponent {
  public readonly deviceStatus = input.required<DeviceSyncStatus>();
  SyncType = SyncType;
}
